// src/pages/New/components/CategorySelector.styles.ts
import styled from "styled-components";

export const CategoryContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
`;

export const CategoryBox = styled.div<{ isActive: boolean }>`
  background-color: ${(props) =>
    props.isActive ? props.theme.tokens.colors.softTeal : props.theme.tokens.colors.surface};

  border: 2px solid
    ${(props) => (props.isActive ? props.theme.tokens.colors.teal : props.theme.tokens.colors.softBg)};

  border-radius: ${(props) => props.theme.tokens.radii.lg}px;
  box-shadow: ${(props) => props.theme.tokens.shadows.card};
  width: 150px;
  height: 150px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;

  font-family: ${(props) => props.theme.tokens.font.family};
  font-weight: 800;
  font-size: 13.5px;
  color: ${(props) => (props.isActive ? props.theme.tokens.colors.teal : props.theme.tokens.colors.ink)};

  cursor: pointer;
`;

export const CategoryImage = styled.img`
  width: 40px;
  height: 40px;
`;
